export const ActionTypes = {
    Alert: 'APP_ALERT',
    CloseToast: 'APP_CLOSE_TOAST',
    Confirm: 'APP_CONFIRM',
    Dialog: 'APP_DIALOG',
    ExpandNode: 'APP_EXPAND_NODE',
    UnselectNode: 'APP_UNSELECT_WELL',
    UnselectNodes: 'APP_UNSELECT_WELLS',
    Loading: 'APP_LOADING',
    Toast: 'APP_TOAST',
    TransitionTo: 'APP_TRANSITION_TO'
};
